import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import { sendOtpThunk, submitFormThunk, verifyOtpThunk } from "./thunk";

const sendOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const sendOtpSlice = createSlice({
  name: "sendOtp",
  initialState: sendOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(sendOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(sendOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const verifyOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const verifyOtpSlice = createSlice({
  name: "verifyOtp",
  initialState: verifyOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(verifyOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(verifyOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const submitFormInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const submitFormSlice = createSlice({
  name: "submitForm",
  initialState: submitFormInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitFormThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(submitFormThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(submitFormThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetSendOtp } = sendOtpSlice.actions;
export const { reset: resetVerifyOtp } = verifyOtpSlice.actions;
export const { reset: resetSubmitForm } = submitFormSlice.actions;

const reducers = combineReducers({
  sendOtp: sendOtpSlice.reducer,
  verifyOtp: verifyOtpSlice.reducer,
  submitForm: submitFormSlice.reducer,
});

export default reducers;
